<template>
  <div class="card text-dark bg-light mb-3 mt-3">
    <div class="card-header">
      <strong>Pickups:</strong>
      {{ pickup }}
    </div>
    <div class="card-body">
      <h5 class="card-title">Bulk {{type}} Pickup</h5>
      <p class="card-text">
        {{ msg }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BulkTypeCard",
  props: {
    msg: String,
    type: String,
    pickup: String,
    id: String
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>